import React from "react"
import { CONDITION_DETAILS, STATUS_CONDITION_PROPERTY } from "utils/workflowHelpers"
import { snakeToCapitalCase } from "utils/stringHelpers"
import { workflowConditionShape } from "utils/propTypeShapes"
import types from "prop-types"
import { Select } from "shared/selects"
import FormsyValidation from "shared/FormsyValidation"

const OPTIONS = CONDITION_DETAILS[STATUS_CONDITION_PROPERTY].operators.map((op) => ({
  value: op,
  label: snakeToCapitalCase(op),
}))

const DefineStatusOperator = ({ condition, conditionIndex, changeConditionOperator }) => (
  <span className="relative">
    <Select
      backspaceDelete={false}
      style={{ height: "32px" }}
      onChange={changeConditionOperator}
      options={OPTIONS}
      placeholder="Select operator ... *"
      required
      value={condition.operator}
      label="select operator for status"
    />
    <FormsyValidation
      name={`conditions[${conditionIndex}].operator`}
      value={condition?.operator ?? ""}
      validations={{ isNotBlankString: true }}
      validationErrors={{ isDefaultRequiredValue: "required" }}
    />
  </span>
)

DefineStatusOperator.propTypes = {
  condition: workflowConditionShape.isRequired,
  changeConditionOperator: types.func.isRequired,
  conditionIndex: types.number.isRequired,
}

export default DefineStatusOperator
